import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import FeatureVideo from '../../ui/FeatureVideo'
import featureVideo from '../../../../assets/videos/biblioteca.mp4'

export default function Documents({ textVariants }) {
  return (
    <div className="flex flex-col lg:flex-row-reverse items-center gap-4 lg:gap-8">
      <motion.div
        className="w-full lg:w-1/2 flex flex-col items-start text-left order-1"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-100px' }}
        variants={textVariants}
      >
        <span className="badge-info mb-6">Acervo Jurídico</span>
        <h3 className="text-[24px] md:text-[30px] font-bold text-text-primary tracking-tight mb-4">
          Documentos prontos para a sua prática clínica.
        </h3>
        <p className="text-base md:text-[18px] text-text-secondary leading-relaxed mb-0 md:mb-8">
          <span className="hidden md:inline">
            Termos de consentimento ajustados, contratos com clínicas, e orientações pré-fabricadas. Não use templates genéricos de internet. Tenha em mãos a proteção feita por advogados especialistas na *sua* área de atuação. No plano Especialista, 1 especialidade é inclusa e especialidades adicionais custam +40% do valor do plano.
          </span>
          <span className="md:hidden">
            Documentos prontos e ajustados por advogados especialistas — sem templates genéricos da internet.
          </span>
        </p>
        <a href="#planos" className="btn-primary group hidden lg:inline-flex">
          Assinar a plataforma
          <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
        </a>
      </motion.div>

      <div className="w-full lg:w-1/2 flex items-center justify-center order-2">
        <FeatureVideo videoSrc={featureVideo} label="Acervo Jurídico" />
      </div>

      <div className="w-full lg:hidden order-3">
        <a href="#planos" className="btn-primary group w-full justify-center">
          Assinar a plataforma
          <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
        </a>
      </div>
    </div>
  )
}
